export const AdminRuntimeStorageKey = 'hypris-admin-runtime'
